export const EXTERN_KEY_PREFIX = 'EXTERN_KEY_PREFIX';
